var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRetargeting = function SvgRetargeting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.427 2A3.427 3.427 0 0 1 5.1 8.788l-.061.01v4.552l.058.011a3.428 3.428 0 0 1 2.759 3.332l-.004.18-.012.181a3.427 3.427 0 1 1-4.08-3.693l.058-.01V8.797l-.061-.01A3.428 3.428 0 0 1 1.002 5.55l-.001-.183.008-.185A3.427 3.427 0 0 1 4.427 2zm10.755.198a.61.61 0 0 1 .069.781l-.063.077-1.776 1.774h2.283a2.491 2.491 0 0 1 2.469 2.177l.014.155.006.157v6.032l.061.01a3.428 3.428 0 0 1 2.754 3.24l.001.182-.008.185a3.427 3.427 0 1 1-4.09-3.606l.06-.012V7.32a1.27 1.27 0 0 0-1.026-1.246l-.119-.017-.122-.006h-2.283l1.777 1.777a.61.61 0 0 1-.788.924l-.076-.062-2.817-2.817a.61.61 0 0 1-.063-.79l.063-.073 2.818-2.82a.61.61 0 0 1 .856.008zM4.427 14.502a2.207 2.207 0 1 0 0 4.413 2.207 2.207 0 0 0 0-4.413zm13.146 0a2.207 2.207 0 1 0 0 4.413 2.207 2.207 0 0 0 0-4.413zM4.427 3.234a2.207 2.207 0 1 0 0 4.414 2.207 2.207 0 0 0 0-4.414z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};

export default SvgRetargeting;